import React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Box } from '@mui/material';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import 'react-perfect-scrollbar/dist/css/styles.css';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { CookiesProvider } from 'react-cookie';
import Tokens from './pages/Tokens';
import TokensNew from './pages/TokensNew';
import Login from './pages/common/Login';
import AppLogin from './pages/common/AppLogin';
import LoginError from './pages/LoginError';
import * as RouterPath from './data/RouterPath';

import Header from './components/Header';
import Footer from './components/Footer';

const theme = createTheme({
  palette: {
    primary: {
      // = _var.scss/$primary
      main: '#5D5FEF',
      contrastText: '#ffffff',
    },
    secondary: {
      // = _var.scss/$secondary
      main: '#7879F1',
      contrastText: '#ffffff',
    },
  },
});

function App() {
  const { pathname } = useLocation();

  const routes = (
    <Routes>
      <Route
        path={RouterPath.ROOT}
        element={<Navigate replace to={RouterPath.LOGIN} />}
      />
      <Route path={RouterPath.LOGIN} element={<Login />} />
      <Route path={RouterPath.TOKENS} element={<Tokens />} />
      <Route path={RouterPath.TOKENS_NEW} element={<TokensNew />} />
      <Route path={RouterPath.APP_LOGIN} element={<AppLogin />} />
      <Route path="/LoginError" element={<LoginError />} />
      <Route path="/*" element={<Navigate replace to="/LoginError" />} />
    </Routes>
  );

  const isHeadNeeded =
    pathname === RouterPath.TOKENS ||
    pathname === RouterPath.TOKENS_NEW ||
    pathname === RouterPath.ROOT;

  return (
    <ThemeProvider theme={theme}>
      <CookiesProvider>
        <Box className="renewal">
          <PerfectScrollbar>
            <Box className={isHeadNeeded ? 'wrapper pat' : 'wrapper'}>
              {(isHeadNeeded && (
                <>
                  <Header />
                  <Box component="main" className="container">
                    {routes}
                  </Box>
                </>
              )) ||
                routes}
            </Box>
            <Footer />
          </PerfectScrollbar>
        </Box>
      </CookiesProvider>
    </ThemeProvider>
  );
}

export default App;
